/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { FeatureCollection } from '../models/feature-collection';
import { getCustomMapStations } from '../fn/map/get-custom-map-stations';
import { GetCustomMapStations$Params } from '../fn/map/get-custom-map-stations';

@Injectable({ providedIn: 'root' })
export class MapService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getCustomMapStations()` */
  static readonly GetCustomMapStationsPath = '/custom/map';

  /**
   * Retrieve stations geolocalized on map, filter on user rights.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCustomMapStations()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getCustomMapStations$Response(params: GetCustomMapStations$Params, context?: HttpContext): Observable<StrictHttpResponse<FeatureCollection>> {
    return getCustomMapStations(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve stations geolocalized on map, filter on user rights.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCustomMapStations$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getCustomMapStations(params: GetCustomMapStations$Params, context?: HttpContext): Observable<FeatureCollection> {
    return this.getCustomMapStations$Response(params, context).pipe(
      map((r: StrictHttpResponse<FeatureCollection>): FeatureCollection => r.body)
    );
  }

}
